"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionalValidator = exports.OneOfValidator = exports.AnyOfValidator = exports.AllOfValidator = void 0;
const validator_1 = require("./validator");
const provider_1 = require("./provider");
class AllOfValidator extends validator_1.BaseValidator {
    validators;
    constructor(validators) {
        super();
        this.validators = validators;
    }
    async entry({ rootCtx, ctx, options }) {
        for (const validator of this.validators) {
            await validator.entry({
                rootCtx,
                ctx,
                options: (0, validator_1.createChildOptions)(options, { applyDefaults: false })
            });
        }
    }
    getAllPossibleInterpretations() {
        return this.validators.flatMap(validator => validator.getAllPossibleInterpretations());
    }
    getAllPossibleTags() {
        return this.validators.flatMap(validator => validator.getAllPossibleTags());
    }
}
exports.AllOfValidator = AllOfValidator;
class AnyOfValidator extends validator_1.BaseValidator {
    validators;
    constructor(validators) {
        super();
        this.validators = validators;
    }
    async entry({ rootCtx, ctx, options }) {
        const bufferCtx = ctx.clone();
        for (const validator of this.validators) {
            const itemCtx = ctx.clone();
            await validator.entry({
                rootCtx,
                ctx: itemCtx,
                options: (0, validator_1.createChildOptions)(options, { applyDefaults: false })
            });
            if (itemCtx.errors.length === 0) {
                ctx.mergeLogItems(itemCtx);
                return;
            }
            bufferCtx.mergeLogItems(itemCtx);
        }
        ctx.mergeLogItems(bufferCtx);
    }
    getAllPossibleInterpretations() {
        return this.validators.flatMap(validator => validator.getAllPossibleInterpretations());
    }
    getAllPossibleTags() {
        return this.validators.flatMap(validator => validator.getAllPossibleTags());
    }
}
exports.AnyOfValidator = AnyOfValidator;
class OneOfValidator extends validator_1.BaseValidator {
    validators;
    constructor(validators) {
        super();
        this.validators = validators;
    }
    async entry({ rootCtx, ctx, options }) {
        const bufferCtx = ctx.clone();
        let count = 0;
        for (const validator of this.validators) {
            const itemCtx = ctx.clone();
            await validator.entry({
                rootCtx,
                ctx: itemCtx,
                options: (0, validator_1.createChildOptions)(options, { applyDefaults: false })
            });
            if (itemCtx.errors.length === 0) {
                bufferCtx.mergeLogItems(itemCtx);
                count += 1;
            }
        }
        if (count === 1) {
            ctx.mergeLogItems(bufferCtx);
        }
        else {
            ctx.addError({ oneOf: true });
        }
    }
    getAllPossibleInterpretations() {
        return this.validators.flatMap(validator => validator.getAllPossibleInterpretations());
    }
    getAllPossibleTags() {
        return this.validators.flatMap(validator => validator.getAllPossibleTags());
    }
}
exports.OneOfValidator = OneOfValidator;
class ConditionalValidator extends validator_1.BaseValidator {
    if;
    then;
    else;
    constructor($if, $then, $else) {
        super();
        this.if = $if;
        this.then = $then;
        this.else = $else;
    }
    async entry({ rootCtx, ctx, options }) {
        const ifCtx = ctx.clone();
        if ((0, provider_1.isProvider)(this.if)) {
            const [, value] = await this.if.evaluate({ rootCtx, ctx: ifCtx });
            if (value === true) {
                await this.then.entry({ rootCtx, ctx, options });
            }
            else {
                await this.else.entry({ rootCtx, ctx, options });
            }
        }
        else {
            await this.if.entry({
                rootCtx,
                ctx: ifCtx,
                options: (0, validator_1.createChildOptions)(options, { applyDefaults: false })
            });
            if (ifCtx.errors.length === 0) {
                await this.then.entry({ rootCtx, ctx, options });
            }
            else {
                await this.else.entry({ rootCtx, ctx, options });
            }
        }
    }
    getAllPossibleInterpretations() {
        return [
            ...this.if.getAllPossibleInterpretations(),
            ...this.then.getAllPossibleInterpretations(),
            ...this.else.getAllPossibleInterpretations()
        ];
    }
    getAllPossibleTags() {
        return [
            ...this.if.getAllPossibleTags(),
            ...this.then.getAllPossibleTags(),
            ...this.else.getAllPossibleTags()
        ];
    }
}
exports.ConditionalValidator = ConditionalValidator;
